import React from "react";
import { Alert } from '@sainsburys-tech/fable';
import { AlertCircleFilled } from '@sainsburys-tech/icons'

const BannerListItem = props => (
  <div className="fable:pb-4">
    <Alert
      {...props}
      leadingIcon={<AlertCircleFilled />}
      isOpen={props.isOpen !== false}
      status={props.status || "error"}
    >
      <span style={{ color: "#ffffff" }}>{props.children}</span>
    </Alert>
  </div>
);

export default BannerListItem;
